export const GoogleMapsAddressSearchQueryKeys = {
  all: ["google", "address"] as const,
  autocomplete: (...args: unknown[]) => [...GoogleMapsAddressSearchQueryKeys.all, "autocomplete", ...args] as const,
};
